import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CompetenceUpdateRequest } from './requests/update-request';
import { Compétence } from '../croisement-référentiel/models/compétences';
import { Response } from '../shared/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class CompétenceService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/compétences';

  modifier = (id: string, data: CompetenceUpdateRequest, idReferentiel: string) => {
    let params = new HttpParams().append('idReferentiel', idReferentiel);

    return this.#http.put<void>(this.BASE_URL + '/' + id, data, { params });
  };

  getAll = (idAptitude: string, idReferentiel: string) => {
    let params = new HttpParams().append('idAptitude', idAptitude).append('idReferentiel', idReferentiel);

    return this.#http.get<Response<Compétence>>(this.BASE_URL, { params });
  };

  supprimer = (idCompetence: string) => {
    return this.#http.delete<void>(this.BASE_URL + '/' + idCompetence);
  };
}
